import { makeStyles } from '@mui/styles';
import { defaultIcon } from '../../default';

const defaultAfter = {
  top: 'calc(50% + .6em)',
  width: '.55em',
  height: '.75em',
  background: 'none',
  border: '.075em solid currentColor',
  borderRadius: '50%',
};

const defaultUser = {
  ...defaultIcon,
  top: 'calc(50% - .1em)',
  width: '.3em',
  height: '.3em',
  maxHeight: '.3em',
  borderRadius: '50%',
  background: 'none',
  border: '.075em solid currentColor',
  '&:after': {
    ...defaultAfter,
  },
};

const userSymbol = {
  ...defaultUser,
  left: 'calc(50% - .2em)',
};

const userSymbolSymbol = {
  top: '-.175em',
  left: '.65em',
  fontSize: '.75em',
  fontWeight: 'bold',
};

const useStyles = makeStyles({
  user: {
    ...defaultUser,
  },
  userPlus: {
    ...userSymbol,
    '&:before': {
      ...userSymbolSymbol,
      content: "'+'",
    },
  },
  userMinus: {
    ...userSymbol,
    '&:before': {
      ...userSymbolSymbol,
      content: "'-'",
      left: '.75em',
    },
  },
  userRemove: {
    ...userSymbol,
    '&:before': {
      ...userSymbolSymbol,
      content: "'+'",
      top: '-.35em',
      left: '.95em',
      transform: 'rotate(45deg)',
    },
  },
  users: {
    ...defaultUser,
    background: 'currentColor',
    '&:after': {
      ...defaultAfter,
      background: 'currentColor',
    },
  },
});

export default useStyles;
